

















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxTreeList, DxEditing, DxColumn, DxRowDragging, DxLookup, DxRequiredRule } from 'devextreme-vue/tree-list';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import TaskProceduresRepository from '@/modules/tasks/procedures/TaskProceduresRepository';
import TaskTemplatesRepository from '@/modules/tasks/templates/TaskTemplatesRepository';
import notificationService from '@/services/notificationService';
import employeesRepository from '@/modules/employees/employeesRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import projectsRepository from '@/services/projectsRepository';
import {
  DxForm,
  DxItem,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

@Component({
  components: {
    DxTreeList,
    DxEditing,
    DxColumn,
    DxRowDragging,
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxLookup,
    DxRequiredRule,
    DxForm,
    DxItem,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
  },
})
export default class TaskProcedureStartPopup extends Vue {
    @Prop({ required: true })
    private procedureId!: string;

    @Prop({ required: false })
    private projectId!: string;

    @Prop({ required: false })
    private measuringStateNumber!: string;

    private showPopup: boolean = false;
    private saving: boolean = false;
    private loading: boolean = false;
    private procedure: ITaskProcedureDto | null = null;
    private templates: ITaskTemplateDto[] = [];
    private employees: any[] = [];

    private dto: any = {
      projectId: '',
      procedureId: '',
      measuringStateNumber: '',
      items: [],
    };

    public show() {
      this.showPopup = true;
      this.dto = {
        projectId: this.projectId,
        procedureId: this.procedureId,
        measuringStateNumber: this.measuringStateNumber,
        items: [],
      };
      this.loadProcedure();
    }

    public hide() {
      this.showPopup = false;
    }

    private mounted() {
      this.loadEmployees();
    }

    private async loadEmployees() {
        try {
            this.employees = (await employeesRepository.get()).data;
        } catch {
            notificationService.showErrorMessage('Mislukt om de werknemers te laden!');
        }
    }

    private async loadProcedure() {
      try {
        this.loading = true;
        this.templates = (await TaskTemplatesRepository.getAll()).data;
        this.procedure = (await TaskProceduresRepository.getSingle(this.procedureId)).data;

        this.procedure.items.forEach((item) => {
          const template = this.templates.find((o) => o.id === item.templateId);
          const obj = {
            team: template ? template.team : '',
            userId: template ? template.assignedUserId : '',
          };

          this.dto.items.push(Object.assign({}, obj, item));
        });

      } catch (error) {
        notificationService.showAxiosError(error);
      } finally {
        this.loading = false;
      }
    }

    private async save() {
      try {
        this.saving = true;
        const result = await TaskProceduresRepository.start(this.dto);
        notificationService.showSuccessMessage('Taken zijn aangemaakt!');
        this.hide();
      } catch (err) {
          notificationService.showAxiosError(err);
      } finally {
        this.saving = false;
      }
    }

    private onDragChange(e: any) {
        const visibleRows = e.component.getVisibleRows();
        const sourceNode = e.component.getNodeByKey(e.itemData.id);
        let targetNode = visibleRows[e.toIndex].node;

        while (targetNode && targetNode.data) {
            if (targetNode.data.id === sourceNode.data.id) {
                e.cancel = true;
                break;
            }

            targetNode = targetNode.parent;
        }
    }

    private onReorder(e: any) {
        const visibleRows = e.component.getVisibleRows();
        const sourceData = e.itemData;
        const targetData = visibleRows[e.toIndex].data;

        if (e.dropInsideItem) {
            e.itemData.parentId = targetData.id;
            e.component.refresh();
        } else {
            const sourceIndex = this.dto.items.indexOf(sourceData);
            let targetIndex = this.dto.items.indexOf(targetData);

            if (sourceData.parentId !== targetData.parentId) {
                sourceData.parentId = targetData.parentId;
                if (e.toIndex > e.fromIndex) {
                    targetIndex++;
                }
            }

            this.dto.items.splice(sourceIndex, 1);
            this.dto.items.splice(targetIndex, 0, sourceData);
        }
    }

    get employeesOptions() {
        return {
            items: this.employees.filter((o: any) => o.accountEnabled === true),
            displayExpr: 'displayName',
            valueExpr: 'adUserId',
        };
    }

    get rolesOptions() {
        return {
            items: employeesRepository.getTeams(),
            displayExpr: 'text',
            valueExpr: 'value',
        };
    }

    get templatesOptions() {
        return {
            items: this.templates,
            displayExpr: 'name',
            searchExpr: 'name',
            valueExpr: 'id',
            searchEnabled: true,
            showClearButton: true,
        };
    }

    get projectsOptions() {
      const self = this;
      return {
        dataSource: new DataSource({
          store: new dxCustomStore({
            key: 'id',
            load: async (loadOptions: any) => {
              if (Array.isArray(loadOptions.filter) &&
                loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {

                return {
                  data: [],
                  totalCount: 0,
                };
              }
              if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
                loadOptions.filter =
                  [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
              }

              const result = await projectsRepository.lookup(loadOptions);
              return {
                data: result.data.data,
                totalCount: result.data.totalCount,
              };
            },
            byKey: async (val: any) => {
              return projectsRepository.getSingle(val).then((result: any) => {
                return result.data;
              });
            },
          }),
          paginate: true,
        }),
        valueExpr: 'id',
        displayExpr: 'name',
        searchExpr: 'name',
        searchEnabled: true,
        showClearButton: true,
      };
    }
}
